import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'message-date-divider',
    templateUrl: './message-date-divider.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageDateDividerComponent {
    public readonly date = input<Date>();
}
